import React from 'react';
import { useSelector } from 'react-redux';
import SearchBar from '~/components/SearchBar';
import { EAA_Item, EAA_ItemContainer, EAA_Select, EAA_Row, EAA_TitleText, EAA_Add_Btn } from '~/components/EditAndAddItem';

const emptyBody = {
  dock: '',
  dock_num: '',
};

const App = props => {
  const { disabled, data, changeData } = props;
  const PSPierList = useSelector(state => state.data.PSPierList || []);

  const returnIdList = value => {
    for (const o of PSPierList) {
      if (value === o.value) return o.idList;
    }
    return [];
  };

  const ary = data.sub3 || [];
  if (ary.length === 0)ary.push({ ...emptyBody });

  const saveSub = dataAry => {
    changeData({ label: 'sub3', data: dataAry });
  };

  const addRow = () => {
    ary.push({ ...emptyBody });
    saveSub(ary);
  };

  const delRow = n => {
    ary.splice(n, 1);
    saveSub(ary);
  };

  return (
    <SearchBar style={{ marginTop: 8 }} text='運維碼頭' defaultOpen>
      {ary.map((o, i) => {
        const isFirst = i === 0;
        return (
          <EAA_Row key={`PierSystem_sub3_${i}`}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text={isFirst ? '港口' : ''} subtitle='' bol={isFirst} />
                <EAA_Select displayBorder disabled={disabled} list={PSPierList} value={o.dock} onChange={data => { ary[i].dock = data; ary[i].dock_num = ''; saveSub(ary); }} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText text={isFirst ? '碼頭編號' : ''} subtitle='' bol={isFirst} />
                <EAA_Select displayBorder disabled={disabled || o.dock === ''} list={returnIdList(o.dock)} value={o.dock_num} onChange={data => { ary[i].dock_num = data; saveSub(ary); }} />
              </EAA_ItemContainer>
              {/* {errorAry[0] && <ErrorText text='帳號需為 1 ~ 100 英數字。' />} */}
            </EAA_Item>
            <EAA_Add_Btn disabled={disabled} del={i > 0} onClick={(i > 0) ? () => delRow(i) : () => addRow()} />
          </EAA_Row>
        );
      })}
    </SearchBar>
  );
};
export default App;
